import pagination from '../../utils/pagination'
import {
  SCHEDULED_CALLS_BATCH_DELETE_REQUEST, SCHEDULED_CALLS_BATCH_DELETE_SUCCESS, SCHEDULED_CALLS_BATCH_DELETE_FAILURE,
  SCHEDULED_CALLS_FETCH_MANY_REQUEST, SCHEDULED_CALLS_FETCH_MANY_SUCCESS, SCHEDULED_CALLS_FETCH_MANY_FAILURE,
  SCHEDULED_CALLS_FETCH_REQUEST, SCHEDULED_CALLS_FETCH_SUCCESS, SCHEDULED_CALLS_FETCH_FAILURE,
  SCHEDULED_CALLS_SAVE_REQUEST, SCHEDULED_CALLS_SAVE_SUCCESS, SCHEDULED_CALLS_SAVE_FAILURE,

  EMPTY_SCHEDULED_CALLS,
  CLEAR_ERRORS
} from './types'

export default {
  [SCHEDULED_CALLS_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [SCHEDULED_CALLS_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [SCHEDULED_CALLS_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [SCHEDULED_CALLS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [SCHEDULED_CALLS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [SCHEDULED_CALLS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [SCHEDULED_CALLS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [SCHEDULED_CALLS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [SCHEDULED_CALLS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [SCHEDULED_CALLS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [SCHEDULED_CALLS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [SCHEDULED_CALLS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_SCHEDULED_CALLS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  },
}
